module.exports = __webpack_public_path__ + "img/turbo_on.c7069b2d.png";